/* index.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./index.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { useCallback } from 'react';
import { IntlProvider, useIntl } from 'react-intl-next';
import { Label } from '@atlaskit/form';
import { SpotlightTarget } from '@atlaskit/onboarding';
import { Box } from '@atlaskit/primitives/compiled';
import Select from '@atlaskit/select';
import { SPOTLIGHT_SITE_SELECTOR_TARGET } from './constants';
import messages from './messages';
var styles = {
  container: "_p12f1w81"
};
function SitePicker(_ref) {
  var sites = _ref.sites,
    selectedCloudId = _ref.selectedCloudId,
    setCloudId = _ref.setCloudId;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var formatOption = function formatOption(site) {
    return {
      label: site.siteUrl,
      value: site.cloudId
    };
  };
  var getSiteFromCloudId = useCallback(function (cloudId) {
    return sites.find(function (site) {
      return site.cloudId === cloudId;
    });
  }, [sites]);
  return /*#__PURE__*/React.createElement(Box, {
    xcss: styles.container
  }, /*#__PURE__*/React.createElement(Label, {
    htmlFor: "conversation-assistant-site-picker"
  }, formatMessage(messages.sitePickerLabel)), /*#__PURE__*/React.createElement(Select, {
    id: "conversation-assistant-site-picker",
    testId: "conversation-assistant-site-picker",
    options: sites.map(function (site) {
      return formatOption(site);
    }),
    onChange: function onChange(option) {
      if (option) {
        setCloudId(option.value);
      }
    },
    label: formatMessage(messages.sitePickerLabel),
    value: formatOption(getSiteFromCloudId(selectedCloudId) || sites[0])
  }));
}
export default function ConversationAssistantSitePicker(_ref2) {
  var sites = _ref2.sites,
    selectedCloudId = _ref2.selectedCloudId,
    setCloudId = _ref2.setCloudId;
  return /*#__PURE__*/React.createElement(IntlProvider, {
    locale: "en"
  }, /*#__PURE__*/React.createElement(SpotlightTarget, {
    name: SPOTLIGHT_SITE_SELECTOR_TARGET
  }, /*#__PURE__*/React.createElement(SitePicker, {
    sites: sites,
    selectedCloudId: selectedCloudId,
    setCloudId: setCloudId
  })));
}